export enum ModalNames {
  Login = 'login',
  Registration = 'registration',
  ForgottenPassword = 'forgotten-password',
  ChangePassword = 'change-password',
  Membership = 'membership',
  AutoSelectionTickets = 'auto-selection-tickets',
  SeatMapSelectionTickets = 'seat-map-selection-tickets',
  TransferTicket = 'transfer-ticket',
  TransferTicketToEmail = 'transfer-ticket-to-email',
  MembershipCard = 'membership-card-modal',
  Payment = 'payment-modal',
  BuySeasonTicket = 'buy-season-ticket',
  HomepageModal = 'homepage-modal',
  EventModal = 'event-modal',
  Notification = 'notification'
}